<script>
import { Helper } from '@/mixin/helper'
import { getClient } from '@/services/identity'
import RestEditableTable from '@/components/RestEditableTable'
import * as deviceStatusApi from '../lib/deviceStatus'
import { mapGetters } from 'vuex'

const identityClient = getClient()

export default {
  components: {
    RestEditableTable,
  },
  mixins: [Helper],
  data() {
    return {
      isTableDataAvailable: true,
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    title() {
      return 'Jenis Kendaraan'
    },

    fields() {
      return [
        {
          key: 'id',
          editable: false,
          thClass: 'd-none',
          tdClass: 'd-none',
        },
        {
          key: 'status',
          thClass: 'mc-table--150',
          editable: true,
          label: 'Status',
          placeholder: 'Status',
          _type: 'text',
          validation: [['required']],
        },
        {
          key: 'description',
          thClass: 'mc-table--150',
          editable: true,
          label: 'Desc',
          placeholder: 'Desc',
          _type: 'text',
        },
        {
          key: 'icon',
          editable: true,
          thClass: 'd-none',
          tdClass: 'd-none',
        },
      ]
    },
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
    }),
    apiClient() {
      return {
        get: deviceStatusApi.get,
        show: deviceStatusApi.show,
        store: deviceStatusApi.store,
        delete: deviceStatusApi.deleteMany,
        update: deviceStatusApi.update,
      }
    },
    queries() {
      return {
        deviceTypes: async (opts) => {
          if (opts) {
            const { limit = 10, page = 1, search = '' } = opts;
            const deviceTypes = deviceStatusApi.constants.data.deviceTypes;

            const filteredDeviceTypes = deviceTypes.filter((device) =>
              device.device_name.toLowerCase().includes(search.toLowerCase())
            );

            const startIndex = (page - 1) * limit;
            const paginatedResult = filteredDeviceTypes.slice(startIndex, startIndex + limit);

            const res = {
              metadata: {
                total_page: Math.ceil(filteredDeviceTypes.length / limit),
                total_count: filteredDeviceTypes.length,
                count: paginatedResult.length,
                page: page,
              },
              data: {
                paginated_result: paginatedResult,
              },
            };

            return res;
          }
        },
        subscriptionType: async (opts) => {
          if (opts) {
            const subscription = await identityClient.get(
              `api/subscription?page=${opts?.page.toString()}&limit=${
                opts?.limit.toString()
              }&_subscription(subscription,like)=${opts?.search || ''}`
            )
            
            const paginatedResult = subscription?.data.data.pagination_result ?? []

            const res = {
              metadata: {
                total_page: subscription?.data.metadata.total_page,
                total_count: subscription?.data.metadata.total_count,
                count: paginatedResult.length,
                page: subscription?.data.metadata.page,
              },
              data: {
                paginated_result: paginatedResult,
              },
            }

            return res
          }
        },
        deviceStatusOpt: (opts) => {
          const { limit = 10, page = 1, search = '' } = opts || {};
          const intervals = deviceStatusApi.constants.data.intervals;

          const filteredIntervals = intervals.filter((interval) =>
            interval.interval_name.toLowerCase().includes(search.toLowerCase())
          );

          const startIndex = (page - 1) * limit;
          const paginatedResult = filteredIntervals.slice(startIndex, startIndex + limit);

          const res = {
            data: paginatedResult,
            has_more: page * limit < filteredIntervals.length,
            page: page,
            size: paginatedResult.length,
            total_count: filteredIntervals.length,
            total_page: Math.ceil(filteredIntervals.length / limit),
          };

          return res;
        }
      }
    },
    exception() {
      const exceptionFields = ['manufacturer']
      return exceptionFields
    },
  },
  methods: {
    handleDataAvailable(isAvailable) {
      this.isTableDataAvailable = isAvailable
    },
    isContains(search, name) {
      const searchContains = RegExp(search ?? '', 'gi').exec(name ?? '')
      return searchContains != null && searchContains.length > 0
    },
    async handleChange() {
      const deviceStatusRef = this.$refs.deviceStatusRef.$refs
      await this.$nextTick()
      this.fields.forEach((field) => {
        if (!field.editable) return
        deviceStatusRef[`${field.key}-ref`].$el.addEventListener(
          'keydown',
          Helper.methods.preventTabKey
        )
      })
    },
  },
}
</script>

<template>
  <div>
    <div class="card">
      <div class="card-body">
        <RestEditableTable
          ref="deviceStatusRef"
          :fields="fields"
          :apiClient="apiClient"
          :bulkDeleteApi="true"
          :hidePagination="true"
          :showNoData="!isTableDataAvailable"
          :enableDeleteButton="hasAccessAll(['device-status-log:delete'])"
          :enableAddButton="hasAccessAll(['device-status-log:create'])"
          :isEnableEditButton="hasAccessAll(['device-status-log:update'])"
          @available-change="handleDataAvailable"
          trackBy="device_status_id"
          @changeData="handleChange"
        />
      </div>
    </div>
  </div>
</template>
